import { autoinject, join } from 'aurelia-framework';
import { EnvironmentService } from 'app/shared/services/environment-service';
import { AppLogger } from 'app/shared/lib/logging/app-logger';
import { httpRequest } from 'app/shared/services/http-service';

@autoinject
export class HelpService {

    private topics: any;

    constructor(private readonly env: EnvironmentService, private readonly logger: AppLogger) {
        this.logger.source = this;
        this.logger.target = 'console';
    }

    public async resolveHelpUrl(topic: string): Promise<string> {
        const baseUrl = this.env.config.help.baseUrl;
        if(!baseUrl) {
            this.logger.warn('Help Base URL Not Configured!');
            return '';
        }

        if(!this.topics) {
            this.logger.info('Loading Help Topic Configuration...');
            const topicConfig = this.env.config.help.topicConfiguration;
            if(topicConfig) {
                const configUrl = this.env.resolveUrl(topicConfig);
                const topics = await httpRequest(configUrl, { format: 'json', cache: 'none' });
                if(topics && typeof topics === 'object') {
                    this.logger.info('Help Topic Configuration Loaded.');
                    this.topics = topics;
                }
            }
            else {
                this.topics = {};
            }
        }

        let topicUrl = '';
        if(this.topics) {
            this.logger.info(`Looking Up Help Topic '${topic}'...`);
            const mappedUrl = this.lookupKey(this.topics, topic);
            if(typeof mappedUrl === 'string') {
                this.logger.info(`Mapped Help Topic '${topic}' to '${mappedUrl}'.`);
                topicUrl = mappedUrl;
            }
        }

        if(!topicUrl) {
            this.logger.warn('Topic Not Found and No Default Topic Configured!');
            return '';
        }

        return join(baseUrl, topicUrl);
    }

    private lookupKey(target: any, topic: string): any {
        // TODO: this is probably useful as a utility function
        const keyParts = topic.split('.');
        let current: any = target;
        for(let keyPart of keyParts) {
            if(current === null || current === undefined)
                return undefined;
            current = current[keyPart];
        }
        return current;
    }

}
